import React from 'react';

/**
 * TutorialHighlight wraps elements that should be highlighted during the tutorial
 * 
 * @param {React.ReactNode} children - Child elements to wrap
 * @param {string} target - The target identifier for this element
 * @param {string} currentTarget - The current active target in the tutorial
 * @param {boolean} active - Whether the tutorial is active
 * @param {string} className - Additional CSS classes to apply
 */
const TutorialHighlight = ({ 
  children, 
  target = '', 
  currentTarget = '', 
  active = false,
  className = ""
}) => {
  // Safety check - if no target or no children, just render children without highlight
  if (!target || !children) {
    return <>{children}</>;
  }
  
  // Determine if this element should be highlighted
  const isHighlighted = active && target === currentTarget;
  
  // Determine special highlight classes based on target
  const getSpecialHighlightClass = () => {
    switch (target) {
      case 'sidebar':
        return 'tutorial-highlight-sidebar';
      case 'confidence':
        return 'tutorial-highlight-confidence';
      default:
        return '';
    }
  };
  
  // Apply appropriate classes
  const highlightClass = isHighlighted 
    ? `tutorial-highlight ${getSpecialHighlightClass()}` 
    : '';
  
  // Intercept clicks during active tutorial
  const handleClick = (e) => {
    if (active) {
      // Prevent the click from reaching the children when in tutorial mode
      e.preventDefault();
      e.stopPropagation();
      console.log(`Tutorial active: Prevented interaction with ${target}`);
    }
  };
  
  return (
    <div 
      className={`${className} ${highlightClass}`} 
      target={target}
      data-target={target}
      onClick={active ? handleClick : undefined}
      style={{ pointerEvents: active ? 'all' : 'auto' }}
    >
      {children}
    </div>
  );
};

export default TutorialHighlight; 